export const EStatusDistributionAvailableAndHistory = {
    DistributionApproved: 1,
    DistributionPending: 2,
    ApprovingPending: 3,
    Approved: 4,
    Pending: 5,
    DistributionExpired: 6
}